export class HRConfigEnterprise {
  hrConfigId:        string;
  enterpriseId:      number;
  active:            boolean;
  enterpriseName: string = '';
}
